// Company: Ajinsoft
// Author: Uilan Coqueiro
// Date: 2024-02-02

import { ApiConfig } from '@ajin/config/api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SettingApiService {
	private _url = ApiConfig.url + 'settings';
	private _supportUrl = ApiConfig.url + 'setting-supports';
	private _httpClient = inject(HttpClient);

	getFeature(packId: string, feature: string): Observable<any> {
		return this._httpClient.get(`${this._url}/packs/${packId}/features/${feature}`);
	}

	get(id: string): Observable<any> {
		return this._httpClient.get(`${this._url}/${id}`);
	}

	update(params: any): Observable<any> {
		return this._httpClient.put(`${this._url}`, params);
	}

	support(): Observable<any> {
		return this._httpClient.get(this._supportUrl);
	}

	setDefault(params: any): Observable<any> {
		return this._httpClient.put(`${this._url}/default`, params);
	}

	getDisplaySettings(): Observable<any> {
		return this._httpClient.get(`${this._url}/display-settings`);
	}
}
